<div class="modal-body">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse small"></div>
  </div>
  <form form *ngIf="!model.commentId" (ngSubmit)="onSubmit()" [formGroup]="form" class="mb-20">
    <div class="form-group">
      <textarea class="form-control" [(ngModel)]="model.text" formControlName="text" placeholder="Type comment" rows="3"></textarea>
      <input-errors [control]="form.controls.text" [service]="validationService"></input-errors>
    </div>
  </form>
  <div *ngIf="model.commentId">{{ model.text }}</div>
  <div *ngIf="model.changedAt && model.changedUser" class="comment-author">
    Created {{ model.changedAt | date:'medium' }} by {{ model.changedUser.email }}
  </div>
</div>
<div class="modal-footer pt-15" *ngIf="!model.commentId">
  <div class="button-holder d-flex justify-content-between">
    <button class="btn btn-outline-dark" (click)="onAfterSave.emit(null)">Cancel</button>
    <button class="btn btn-primary ms-15" (click)="onSubmit()" [disabled]="!form.valid">Confirm</button>
  </div>
</div>
